export const getDocumentCount = (payload?: any) => ({
  type: "@saga/GET_DOCUMENT_COUNT",
  payload,
});
